import { Component } from "react";
import Popup from "..";
import AppContext from "../../../contexts/AppContext";
import RectButton from "../../ui/button/RectButton";

class CardSavedPopup extends Component {
    static contextType = AppContext;
    render() {
        return (
            <Popup className="save-card-popup slim">
                <h3>Success</h3>
                <div className="column">
                    <p>Your custom card has been created and is saved in the “My Custom Cards” category!</p>
                    <div className="row lock">
                        <RectButton text="CUSTOMIZE MORE CARDS" onClick={()=>this.context.setPopup(null)} />
                        <RectButton text="TAKE ME THERE" onClick={()=>this.context.setPopup(null)} />
                    </div>
                </div>
            </Popup>
        )
    }
}

export default CardSavedPopup;